import { deleteJourney } from '@state/builders/journeys/helpers'
import { deleteJourneyLeg } from '@state/builders/journey-legs/helpers'
import { getNewJourneysWithLegsByDirections } from '@state/queries/journeys/get-journeys-by-directions.js'

export const deleteNewJourneysWithLegs = (directions) => {
  getNewJourneysWithLegsByDirections(directions).forEach((journey) => {
    journey.legs.forEach((leg) => deleteJourneyLeg(leg.id))

    deleteJourney(journey.id)
  })
}
